import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/note-api/login',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/note-api/bearer',
    method: 'get',
    params: { token }
  })
}

export function register(data) {
  return request({
    url: '/note-api/register',
    method: 'post',
    data
  })
}
